export default "__VITE_PUBLIC_ASSET__b4710716__"